// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.print_report[data-v-01d0da5a] {\n  width: 100%;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
